module.exports = __webpack_public_path__ + "static/media/16_plantilla_rec_combo_simple_cp_stills_pet_500_cepita_fresh_nar.b53cb0d7.png";